<wbo-select-option [value]="TerminalData.STANDARD_TYPE" label="wbo.terminal.option.type.standard">
</wbo-select-option>
<wbo-select-option [value]="TerminalData.FUNCTIONAL_TYPE" label="wbo.terminal.option.type.functional">
</wbo-select-option>
<wbo-select-option [value]="TerminalData.HANDHELD_TYPE" label="wbo.terminal.option.type.handheld">
</wbo-select-option>
